module.exports = __webpack_public_path__ + "244c4f5a4f16e4d4321a4790ded30de7.svg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/sponsors/mozilla.svg
 ** module id = 380
 ** module chunks = 0
 **/